import {
  FETCH_TASKS,
  FETCH_TASKS_SUCCESS,
  FETCH_TASKS_FAILED,
  ACCEPT_TASK,
  CANCEL_TASK,
} from "../store/types";
import store from "../store/store";
import { updateProfile } from "./authactions";
import { RequestPushMsg } from "../other/NotificationFunctions";
import { firebase } from '../config/configureFirebase';
import { onValue, runTransaction, get, off, push } from "firebase/database";
import {driverQueue} from '../other/sharedFunctions';

// Un seul abonnement aux demandes de course ; relancé au retour de l'app au premier plan.
let tasksUnsubscribe = null;

export const fetchTasks = () => (dispatch) => {
  const { auth, tasksRef } = firebase;

  if (!auth.currentUser) return;
  const uid = auth.currentUser.uid;
  if (tasksUnsubscribe) tasksUnsubscribe();
  off(tasksRef());
  dispatch({
    type: FETCH_TASKS,
    payload: null,
  });
  tasksUnsubscribe = onValue(tasksRef(), (snapshot) => {
    if (snapshot.val()) {
      let data = snapshot.val();
      const arr = Object.keys(data)
        .filter(
          (i) => data[i].requestedDrivers && data[i].requestedDrivers[uid]
        )
        .map((i) => {
          data[i].id = i;
          return data[i];
        });
      dispatch({
        type: FETCH_TASKS_SUCCESS,
        payload: arr,
      });
    } else {
      dispatch({
        type: FETCH_TASKS_FAILED,
        payload: store.getState().languagedata.defaultLanguage.no_tasks,
      });
    }
  }, (error) => {
    // Abonnement coupé (session, réseau) : nouvel essai dans 5 s.
    console.warn('fetchTasks listener error', error);
    setTimeout(() => fetchTasks()(dispatch), 5000);
  });
};

// Acceptation d'une course : transaction atomique (un seul chauffeur gagne).
// Renvoie { success: true } ou { success: false, error }.
export const acceptTask = (task) => async (dispatch) => {
  const { auth, trackingRef, singleUserRef, singleBookingRef } = firebase;
  const lang = store.getState().languagedata.defaultLanguage || {};
  const uid = auth.currentUser.uid;

  try {
    const profile = (await get(singleUserRef(uid))).val();
    if (!profile) {
      return { success: false, error: lang.not_logged_in || 'Profil introuvable.' };
    }

    const result = await runTransaction(singleBookingRef(task.id), (booking) => {
      // Premier passage avec un cache local vide : on laisse Firebase relancer avec la vraie valeur.
      if (booking === null) return booking;
      if (booking.status !== 'NEW' || booking.driver || !booking.requestedDrivers || !booking.requestedDrivers[uid]
        || (booking.cancelledDriverIds && booking.cancelledDriverIds[uid])) {
        return; // annule : course déjà prise, annulée ou non proposée à ce chauffeur
      }
      const estimate = parseFloat(booking.estimate) || 0;
      const fees = parseFloat(booking.convenience_fees) || 0;
      const fleetCommission = profile.fleetadmin ? ((estimate - fees) * (parseFloat(booking.fleet_admin_comission) || 0) / 100) : 0;
      booking.driver = uid;
      booking.driver_image = profile.profile_image || '';
      booking.car_image = profile.car_image || '';
      booking.driver_name = [profile.firstName, profile.lastName].filter(Boolean).join(' ');
      booking.driver_contact = profile.mobile || '';
      booking.driver_token = profile.pushToken || '';
      booking.vehicle_number = profile.vehicleNumber || '';
      booking.vehicleModel = profile.vehicleModel || '';
      booking.vehicleMake = profile.vehicleMake || '';
      booking.driverRating = profile.rating || '0';
      booking.fleetCommission = fleetCommission ? fleetCommission.toFixed(2) : '0';
      booking.fleetadmin = profile.fleetadmin || '';
      booking.status = 'ACCEPTED';
      booking.acceptedAt = booking.acceptedAt || Date.now();
      booking.acceptedBy = uid;
      booking.driver_share = (estimate - fees - fleetCommission).toFixed(2);
      booking.driverDeviceId = task.driverDeviceId || null;
      booking.requestedDrivers = null;
      booking.driverEstimates = null;
      return booking;
    });

    const booking = result.snapshot.val();
    if (!result.committed || !booking || booking.driver !== uid) {
      return { success: false, error: lang.booking_taken || 'Cette course a déjà été acceptée par un autre chauffeur ou annulée.' };
    }

    // Une course planifiée dans plus de 40 min ne bloque pas le chauffeur pour d'autres courses.
    const minutesBefore = task.bookLater && task.tripdate ? (new Date(task.tripdate).getTime() - Date.now()) / 60000 : 0;
    const blocks = minutesBefore <= 40;
    await updateProfile({ queue: blocks ? (driverQueue ? false : true) : false })(dispatch);
    if (task.customer_token) {
      RequestPushMsg(task.customer_token, {
        title: lang.notification_title,
        msg: (profile.firstName || '') + lang.accept_booking_request,
        screen: 'BookedCab',
        params: { bookingId: task.id },
      });
    }
    const loc = store.getState().gpsdata.location;
    if (loc && typeof loc.lat === 'number') {
      push(trackingRef(task.id), { at: Date.now(), status: 'ACCEPTED', lat: loc.lat, lng: loc.lng });
    }
    dispatch({ type: ACCEPT_TASK, payload: { task } });
    return { success: true };
  } catch (error) {
    console.warn('acceptTask failed', error);
    return { success: false, error: lang.network_error || 'Connexion impossible. Réessayez.' };
  }
};

export const cancelTask = (bookingId) => (dispatch) => {
  const { auth, singleBookingRef } = firebase;

  const uid = auth.currentUser.uid;

  return runTransaction(singleBookingRef(bookingId), (booking) => {
      if (booking === null) return booking;
      if (booking && booking.requestedDrivers) {
        if (
          booking.requestedDrivers !== null &&
          Object.keys(booking.requestedDrivers).length === 1
        ) {
          booking.status = "NEW";
          booking.requestedDrivers = null;
          booking.driverEstimates = null;
          RequestPushMsg(booking.customer_token, {
            title:
              store.getState().languagedata.defaultLanguage.notification_title,
            msg:
              store.getState().languagedata.defaultLanguage.booking_cancelled +
              bookingId,
            screen: "BookedCab",
            params: { bookingId: bookingId },
          });
          dispatch({
            type: CANCEL_TASK,
            payload: { uid: uid, bookingId: bookingId },
          });
        }else{
          delete booking.requestedDrivers[uid];
        }
        if(booking.driverOffers && booking.driverOffers[uid]){
          delete booking.driverOffers[uid];
        }
        if(booking.selectedBid && booking.selectedBid.driver === uid){
          delete booking.selectedBid;
        }
        return booking;
      }
    });
};
